<div class="splash-bg"></div> 
{#if splashVisible}
  <div class="container splash { !contentVisible ? 'split' : '' }" 
    transition:slide="{transitionConfig}" 
    bind:this={splashContainerElem}>
    <div class="container splash-title">
      <h1>If you live or work in the Hawkesbury-Nepean Valley you are at risk of flood</h1>
    </div>
    {#if contentVisible}
      <div 
        class="container splash-content" 
        transition:fade="{{delay: 250, duration: 300, easing: linear }}"
        on:outrostart={contentVisibleTransitionOutro}>
        <slot />
      </div>
    {/if}
    <div class="container splash-footer">
      <h4>Your home, your family and your animals may be vulnerable when it floods.</h4>
    </div>
  </div>
{/if}

  



<script>
import { fade, slide } from "svelte/transition";
fade;
slide;
import { linear } from "svelte/easing";
linear;
import store, { STATES_MAIN, STATES_FIRST_VISIT, STATES_START } from "../../state";
import { onMount } from "svelte/internal";
//@ts-ignore
import HeroImageMini from "../../assets/images/Hero_Image_Mini_Mobile.png";
//@ts-ignore
import HeroImageFull from "../../assets/images/Hero_Image_Full_Mobile.png";
let contentVisible = true;
let splashVisible = true;
let splashContainerElem;
let readySplashBgFull = "";
let readySplashBgMini = "";
let transitionConfig = {
    delay: 0,
    duration: 0,
    easing: linear
};
$: {
    if (!contentVisible) {
        if (splashContainerElem) {
            splashContainerElem.style.background = "";
        }
    }
}
onMount(() => {
    loadImage(HeroImageFull, () => {
        setupSplashFullResImage(HeroImageFull);
    });
});
store.subscribe(state => {
    const isLanding = state.currentState.includes(`${STATES_MAIN.LANDING}`);
    const isStart = state.currentState === `${STATES_MAIN.START}.${STATES_START.DEFAULT}`;
    if (!isLanding) {
        contentVisible =
            state.currentState ===
                `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.DEFAULT}`;
        if (contentVisible) {
            transitionConfig = Object.assign(Object.assign({}, transitionConfig), { delay: 250, duration: 300 });
        }
    }
    splashVisible = !state.splashHide;
    // This to handle not ftus
    if (isStart) {
        splashVisible = false;
    }
});
function loadImage(imageUrl, cb) {
    const image = new Image();
    image.src = imageUrl;
    image.onload = () => {
        cb();
    };
}
function setupSplashFullResImage(imageUrl, delay) {
    setTimeout(() => {
        if (splashContainerElem) {
            splashContainerElem.style.background = `linear-gradient(
        360deg,
        rgba(30, 30, 30, 0.23) 0%,
        rgba(0, 0, 0, 0.77) 100%
      ),
      url("${imageUrl}")`;
            splashContainerElem.style.backgroundSize = `cover`;
        }
    }, delay);
}
function contentVisibleTransitionOutro() {
    loadImage(HeroImageMini, () => {
        setupSplashFullResImage(HeroImageMini);
    });
}
</script>


<style>.splash{width:100%;display:flex;flex-direction:column;justify-content:space-between;overflow-x:hidden;overflow-y:auto;flex-wrap:nowrap;height:100%;transition:height .3s linear .4s,background .3s linear 0ms;background:linear-gradient(1turn,rgba(30,30,30,.23),rgba(0,0,0,.77)),url(../../assets/images/Hero_Image_Mini_Placeholder.png);background-size:cover;padding:1.65625rem 2.1875rem 0}.splash>:last-child{padding-bottom:2.03125rem}.splash-title{color:#fff;margin-bottom:1.875rem;flex:0}.splash-title h1{text-align:center;font-family:AvenirLT-Black;line-height:30px;font-size:1.375rem}.splash-content{flex:0;margin:0 .25rem}.splash-footer{color:#fff;margin-top:1.625rem;flex:0;font-family:AvenirLT-Light}.splash-footer h4{text-align:center;font-size:1rem;line-height:22px}.splash.split{height:290px}.splash-bg{position:absolute;width:100%;height:100%;background-color:rgba(17,17,17,.71);left:0;top:0}</style>
